import React, { useState } from "react"
import {
	Modal,
	ModalHeader,
	ModalBody,
	TabContent,
	TabPane,
	Nav,
	NavItem,
	NavLink,
} from "reactstrap"
import styles from "./CourtModal.module.scss"
import { ModalEventFooter } from "../../"
import PlayersTab from "./PlayersTab"
import EventTab from "./EventTab"
import FollowupTab from "../../FollowupTab"
import { filterEventsByDelegateType } from "../../../utility/Utils"

const CourtModal = ({ hideModal, coordinates }) => {
	const events = filterEventsByDelegateType()

	const [activeTab, setActiveTab] = useState(1)

	const [selectedPlayer, setSelectedPlayer] = useState({})
	const [selectedEvent, setSelectedEvent] = useState({})

	const [followupPlayer, setFollowupPlayer] = useState({})
	const [followupEvent, setFollowupEvent] = useState()

	const dismissModal = () => {
		hideModal()
		setSelectedPlayer({})
		setSelectedEvent({})
		setFollowupPlayer({})
		setFollowupEvent()
		setActiveTab(1)
	}

	return (
		<Modal
			isOpen={coordinates.x !== undefined}
			toggle={dismissModal}
			className="modal-dialog-centered modal-xl"
		>
			<ModalHeader toggle={dismissModal}>Dodaj event</ModalHeader>
			<Nav tabs>
				<NavItem>
					<NavLink
						active={activeTab === 1}
						onClick={() => setActiveTab(1)}
					>
						Players
					</NavLink>
				</NavItem>
				<NavItem>
					<NavLink
						active={activeTab === 2}
						onClick={() => setActiveTab(2)}
						disabled={!selectedPlayer.name}
					>
						Events
					</NavLink>
				</NavItem>
				<NavItem>
					<NavLink
						active={activeTab === 3}
						onClick={() => setActiveTab(3)}
						disabled={!selectedEvent.followup}
					>
						Followup
					</NavLink>
				</NavItem>
			</Nav>
			<ModalBody className={styles.modalBody}>
				<TabContent activeTab={activeTab}>
					<TabPane tabId={1}>
						<PlayersTab
							setActiveTab={setActiveTab}
							selectedPlayer={selectedPlayer}
							setSelectedPlayer={setSelectedPlayer}
							selectedEvent={selectedEvent}
							setSelectedEvent={setSelectedEvent}
							followupPlayer={followupPlayer}
							setFollowupPlayer={setFollowupPlayer}
							followupEvent={followupEvent}
							setFollowupEvent={setFollowupEvent}
							quickEvents={events.quick}
						/>
					</TabPane>
					<TabPane tabId={2}>
						<EventTab
							setActiveTab={setActiveTab}
							selectedEvent={selectedEvent}
							setSelectedEvent={setSelectedEvent}
							setFollowupPlayer={setFollowupPlayer}
							setFollowupEvent={setFollowupEvent}
							selectedPlayerText={`(${selectedPlayer.tshirtNumber}) ${selectedPlayer.name} ${selectedPlayer.surname}`}
							normalEvents={[...events.quick, ...events.normal]}
						/>
					</TabPane>
					<TabPane tabId={3}>
						<FollowupTab
							followup={selectedEvent.followup}
							selectedPlayer={selectedPlayer}
							setFollowupPlayer={setFollowupPlayer}
							followupPlayer={followupPlayer}
							setFollowupEvent={setFollowupEvent}
							followupEvent={followupEvent}
						/>
					</TabPane>
				</TabContent>
			</ModalBody>

			<ModalEventFooter
				selectedPlayer={selectedPlayer}
				selectedEvent={selectedEvent}
				followupPlayer={followupPlayer}
				followupEvent={followupEvent}
				dismissModal={dismissModal}
				coordinates={coordinates}
			/>
		</Modal>
	)
}

export default CourtModal
